/* COD form — Crown Time. No dependencies. */
(function () {
  if (customElements.get('cod-form-component')) return;

  var ATTRIBUTION_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'utm_id', 'campaign_id', 'ad_id', 'adset_id', 'fbclid', 'ttclid', 'gclid'
  ];

  function money(amount, currency) {
    try {
      return new Intl.NumberFormat('fr-MA', {
        style: 'currency', currency: currency || 'MAD', maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + (currency || 'MAD');
    }
  }

  // Digits only, kept exactly as typed — no "+" and no country prefix added.
  // Deliberately permissive: better to capture a wrong number and call it than
  // to lose the order to a validation rule.
  function normalisePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    return d.length >= 8 && d.length <= 15 ? d : null;
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
  }

  function readCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : null;
  }

  function collectAttribution() {
    var params = new URLSearchParams(location.search);
    var out = {};
    ATTRIBUTION_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) out[k] = v;
    });
    var fbp = readCookie('_fbp');
    var fbc = readCookie('_fbc');
    if (fbp) out._fbp = fbp;
    if (fbc) out._fbc = fbc;
    out.full_url = location.href;
    out.referrer = document.referrer || '';
    return out;
  }

  class CodForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || this.dataset.bound) return;
      this.dataset.bound = '1';

      this.endpoint = this.dataset.endpoint || '/apps/cod/order';
      this.currency = this.dataset.currency || 'MAD';
      this.unitPrice = parseFloat(this.dataset.unitPrice) || 0;

      try {
        this.variants = JSON.parse(this.querySelector('[data-cod-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }

      this.qtyInput = this.querySelector('[name="quantity"]');
      this.submitBtn = this.querySelector('[data-cod-submit]');
      this.spinner = this.querySelector('[data-cod-spinner]');
      this.formError = this.querySelector('[data-cod-form-error]');
      this.successEl = this.querySelector('[data-cod-success]');
      this.summaryEl = this.querySelector('[data-cod-summary]');
      this.totalEl = this.querySelector('[data-cod-total]');

      this.querySelectorAll('[data-cod-qty]').forEach(function (btn) {
        btn.addEventListener('click', this.onQtyStep.bind(this));
      }, this);

      if (this.qtyInput) this.qtyInput.addEventListener('input', this.renderTotal.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('input', this.clearFieldError.bind(this));

      window.addEventListener('popstate', this.syncVariant.bind(this));
      document.addEventListener('variant:update', this.syncVariant.bind(this));

      this.syncVariant();
    }

    currentVariantId() {
      var fromUrl = new URLSearchParams(location.search).get('variant');
      if (fromUrl && this.variants.some(function (v) { return String(v.id) === fromUrl; })) {
        return fromUrl;
      }
      return this.dataset.variantId;
    }

    syncVariant() {
      var id = this.currentVariantId();
      var hidden = this.querySelector('[data-cod-variant]');
      if (hidden) hidden.value = id;
      var v = this.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (v) {
        this.unitPrice = v.price;
        if (this.submitBtn) this.submitBtn.disabled = !v.available;
      }
      this.renderTotal();
    }

    qty() {
      var n = parseInt(this.qtyInput && this.qtyInput.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }

    onQtyStep(e) {
      if (!this.qtyInput) return;
      var step = parseInt(e.currentTarget.dataset.codQty, 10) || 0;
      this.qtyInput.value = Math.max(1, this.qty() + step);
      this.renderTotal();
    }

    renderTotal() {
      if (!this.totalEl || !this.summaryEl) return;
      var total = this.unitPrice * this.qty();
      this.totalEl.textContent = money(total, this.currency);
      this.summaryEl.hidden = false;
    }

    clearFieldError(e) {
      var name = e.target && e.target.name;
      if (!name) return;
      var el = this.querySelector('[data-cod-error-for="' + name + '"]');
      if (el) { el.hidden = true; el.textContent = ''; }
      if (this.formError) this.formError.hidden = true;
    }

    setFieldError(name, message) {
      var el = this.querySelector('[data-cod-error-for="' + name + '"]');
      if (el) { el.textContent = message; el.hidden = false; }
      var input = this.querySelector('[name="' + name + '"]');
      if (input) input.classList.add('is-invalid');
    }

    field(name) {
      // form.name / form.action etc. are HTMLFormElement properties and would
      // shadow the inputs, so always go through elements.namedItem().
      return this.form.elements.namedItem(name);
    }

    validate() {
      var data = {}, ok = true;
      this.querySelectorAll('.is-invalid').forEach(function (n) { n.classList.remove('is-invalid'); });

      var name = (this.field('name').value || '').trim();
      if (name.length < 3) { this.setFieldError('name', 'Merci d’indiquer votre nom complet.'); ok = false; }
      data.name = name;

      var phone = normalisePhone(this.field('phone').value);
      if (!phone) { this.setFieldError('phone', 'Merci d’indiquer un numéro de téléphone.'); ok = false; }
      data.phone = phone;

      var city = (this.field('city').value || '').trim();
      if (city.length < 2) { this.setFieldError('city', 'Merci d’indiquer votre ville.'); ok = false; }
      data.city = city;

      var address = (this.field('address').value || '').trim();
      if (address.length < 5) { this.setFieldError('address', 'Adresse trop courte.'); ok = false; }
      data.address = address;

      if (!ok) {
        var firstBad = this.querySelector('.is-invalid');
        if (firstBad) firstBad.focus({ preventScroll: false });
        return null;
      }
      return data;
    }

    busy(on) {
      if (this.submitBtn) this.submitBtn.disabled = on;
      if (this.spinner) this.spinner.hidden = !on;
      this.classList.toggle('is-busy', on);
    }

    async onSubmit(e) {
      e.preventDefault();
      if (this.submitting) return;

      var data = this.validate();
      if (!data) return;

      this.submitting = true;
      this.busy(true);
      if (this.formError) this.formError.hidden = true;

      var eventId = uuid();
      var payload = Object.assign({}, data, {
        variant_id: this.currentVariantId(),
        product_id: this.dataset.productId,
        quantity: this.qty(),
        event_id: eventId,
        attribution: collectAttribution()
      });

      try {
        var res = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });

        var body = null;
        try { body = await res.json(); } catch (_) {}

        if (!res.ok || !body || !body.ok) {
          throw new Error((body && body.message) || 'Une erreur est survenue. Merci de réessayer.');
        }

        this.onSuccess(body, payload, eventId);
      } catch (err) {
        if (this.formError) {
          this.formError.textContent = err.message || 'Connexion impossible. Merci de réessayer.';
          this.formError.hidden = false;
        }
        this.busy(false);
        this.submitting = false;
      }
    }

    onSuccess(body, payload, eventId) {
      var total = this.unitPrice * payload.quantity;

      // Browser-side Purchase. Server fires the CAPI twin with the same event_id
      // so Facebook deduplicates the pair.
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Purchase', {
            value: total,
            currency: this.currency,
            contents: [{ id: String(payload.variant_id), quantity: payload.quantity }],
            content_type: 'product'
          }, { eventID: eventId });
        }
      } catch (_) {}

      try {
        document.dispatchEvent(new CustomEvent('cod:order-created', { detail: { body: body, payload: payload } }));
      } catch (_) {}

      this.form.hidden = true;
      if (this.successEl) {
        var bodyEl = this.successEl.querySelector('[data-cod-success-body]');
        if (bodyEl && body.order_name) {
          bodyEl.textContent = bodyEl.textContent + ' (' + body.order_name + ')';
        }
        this.successEl.hidden = false;
        this.successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      this.busy(false);
    }
  }

  customElements.define('cod-form-component', CodForm);
})();
